// Centralized registry for editor fonts
// Add new fonts here and they will automatically appear in the Quill font picker
// and be preserved in the editor output.

export type EditorFont = {
  id: string; // font-family name used in CSS/Quill
  label: string; // human-friendly label shown in the picker
};

export const EDITOR_FONTS: EditorFont[] = [
  { id: "B737-800-FMS-Small", label: "B737-800 Small" },
  { id: "B737-800-FMS-Large", label: "B737-800 Large" },
  { id: "A320-FMS-Small", label: "A320 Small" },
  { id: "A320-FMS-Large", label: "A320 Large" },
  { id: "B787-9-FMS-Small", label: "B787-9 Small" },
  { id: "B787-9-FMS-Large", label: "B787-9 Large" },
  { id: "E175-FMS-Large", label: "E175 Large" },
  { id: "E175-FMS-Small", label: "E175 Small" },
  { id: "sans-serif", label: "Sans Serif" },
];

export const getFontIds = (): string[] => EDITOR_FONTS.map((f) => f.id);
